'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { useHasTouchInput } from '@repo/ui';
import { memo, type ReactNode, useState } from 'react';
import { HoverCard, HoverCardContent, HoverCardTrigger, Popover, PopoverContent, PopoverTrigger } from '@/components/common/overlays';
import RiskCuratorCardContent from './RiskCuratorCardContent';
export interface RiskCuratorCardProps {
  curator: {
    id: string;
    name: string;
    image: string | null;
    state?: {
      aum: number;
    } | null;
  };
  chainId: ChainId | null;
  children: ReactNode;
}
const RiskCuratorCard = t0 => {
  const $ = _c(21);
  const {
    curator,
    chainId,
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const hasTouchInput = useHasTouchInput();
  if (hasTouchInput) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(_temp);
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== children) {
      t2 = <PopoverTrigger asChild={true}><div onClick={t1}>{children}</div></PopoverTrigger>;
      $[1] = children;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        padding: 0,
        outline: "none"
      };
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== chainId || $[5] !== curator) {
      t4 = <PopoverContent side="top" sideOffset={8} style={t3} onClick={_temp2}><RiskCuratorCardContent curator={curator} chainId={chainId} /></PopoverContent>;
      $[4] = chainId;
      $[5] = curator;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== isOpen || $[8] !== t2 || $[9] !== t4) {
      t5 = <Popover open={isOpen} onOpenChange={setIsOpen}>{t2}{t4}</Popover>;
      $[7] = isOpen;
      $[8] = t2;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t1;
  if ($[11] !== children) {
    t1 = <HoverCardTrigger asChild={true}><div onClick={_temp3}>{children}</div></HoverCardTrigger>;
    $[11] = children;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      minWidth: "275px",
      maxWidth: "315px"
    };
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== chainId || $[15] !== curator) {
    t3 = <HoverCardContent style={t2} side="top" sideOffset={8} onClick={_temp4}><RiskCuratorCardContent curator={curator} chainId={chainId} /></HoverCardContent>;
    $[14] = chainId;
    $[15] = curator;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== isOpen || $[18] !== t1 || $[19] !== t3) {
    t4 = <HoverCard open={isOpen} onOpenChange={setIsOpen} openDelay={200} closeDelay={100}>{t1}{t3}</HoverCard>;
    $[17] = isOpen;
    $[18] = t1;
    $[19] = t3;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
};
export default memo(RiskCuratorCard);
function _temp(prev) {
  return !prev;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp3(e_1) {
  e_1.stopPropagation();
}
function _temp4(e_2) {
  return e_2.stopPropagation();
}